import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'first_error'
})

export class FirstErrorPipe implements PipeTransform {
    transform(obj:any) {
        if (obj === null)
            return null;

        var keys = Object.keys(obj);

        if (keys && keys.length > 0) {
            return keys[0];
        }

        return null;
    }
}
